"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var common_1 = require("../../../../common");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var general_1 = require("../../../../lib/general");
var Mutation_1 = require("../../Graphql/Mutation");
var Queries_1 = require("../../Graphql/Queries");
var CategorySelector_1 = __importDefault(require("../Selectors/CategorySelector"));
var DataType_1 = __importDefault(require("../Selectors/DataType"));
var KnowledgeSelector_1 = __importDefault(require("../Selectors/KnowledgeSelector"));
var QuestionSelector_1 = __importDefault(require("../Selectors/QuestionSelector"));
var QuestionType_1 = __importDefault(require("../Selectors/QuestionType"));
var validate_1 = require("../validate");
var KnowledgeQuestionAnswer_1 = __importDefault(require("./KnowledgeQuestionAnswer"));
var QuestionTable_1 = __importDefault(require("./QuestionTable"));
var KnowledgeQuestion = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var organization = (0, org_hook_1.useOrg)().organization;
    var _l = (0, react_1.useState)(null), error = _l[0], setError = _l[1];
    var _m = (0, react_i18next_1.useTranslation)(), t = _m.t, i18n = _m.i18n;
    var getCurrentLang = i18n.language;
    var arr1 = props.languages, audioRef = (0, react_1.createRef)();
    var _o = (0, react_1.useState)({
        id: null,
        name: JSON.stringify(props.languages),
        category: null,
        exam_type: null,
        data_type: null,
        sorting_order: null,
        answer: [],
        organization_id: organization.id,
        knowledge: null,
        audio: arr1,
    }), formData = _o[0], setFormData = _o[1];
    var _p = (0, react_1.useState)({ audio: null }), audioFile = _p[0], setAudioFile = _p[1];
    var _q = (0, react_1.useState)([]), knowlegdeList = _q[0], setKnowledgeList = _q[1];
    var _r = (0, react_1.useState)(null), success = _r[0], setSuccess = _r[1];
    var _s = (0, react_1.useState)([]), questionSortingArr = _s[0], setQuestionSortingArr = _s[1];
    var _t = (0, react_1.useState)(false), deleteModal = _t[0], setDeleteModal = _t[1];
    var _u = (0, react_1.useState)(null), deleteRow = _u[0], setDeleteRow = _u[1];
    var _v = (0, client_1.useLazyQuery)(Queries_1.GET_EXAM_QUESTION_ORDER, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
    }), getExamKnowledge = _v[0], examKnowledgeResponse = _v[1];
    var _w = (0, client_1.useMutation)(Mutation_1.UPSERT_KNOWLEDGE_QUESTION_ANSWER, {
        fetchPolicy: "network-only",
        refetchQueries: ["getKnowledgeCategory"],
    }), upsertExamQuestion = _w[0], upsertExamQuestionResponse = _w[1];
    var getQuestionAnswer = (0, client_1.useLazyQuery)(Queries_1.GET_QUESTION_ANSWER, {
        variables: { organization_id: organization.id },
    })[0];
    var updateQuestionExamStatus = (0, client_1.useMutation)(Mutation_1.UPDATA_QUESTION_EXAM_STATUS, {
        fetchPolicy: "network-only",
        refetchQueries: ["getKnowledgeCategory"],
    })[0];
    var reformatForm = function () {
        setFormData({
            id: null,
            name: JSON.stringify(props.languages),
            category: null,
            exam_type: null,
            data_type: null,
            sorting_order: null,
            answer: [],
            organization_id: organization.id,
            knowledge: null,
            audio: arr1,
        });
    };
    var resetDocumentRef = function () {
        audioRef.current.value = null;
    };
    (0, react_1.useEffect)(function () {
        getQuestionAnswer();
        reformatForm();
        resetDocumentRef();
    }, []);
    (0, react_1.useEffect)(function () {
        resetDocumentRef();
        setAudioFile({ audio: null });
    }, [getCurrentLang]);
    (0, react_1.useEffect)(function () {
        if (props.clickStatus) {
            props.updateSaveClickStatus();
            saveQuestionAnswer();
        }
    }, [props.clickStatus]);
    var getVal = function (obj) {
        var tmp = [];
        Object.keys(obj).forEach(function (key) {
            var lang = key, name = obj[key] === "" ? null : obj[key];
            tmp.push({
                lang: lang,
                name: name,
            });
        });
        return tmp;
    };
    var saveQuestionAnswer = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var validateResponse = (0, validate_1.ValidateKnowledgeQuestion)(formData, getCurrentLang);
        if (validateResponse.status === "error") {
            setError(validateResponse);
        }
        else {
            var audioArr = getVal(formData.audio);
            var payload = {
                id: formData.id,
                knowledge_category_id: ((_a = formData.category) === null || _a === void 0 ? void 0 : _a.id)
                    ? (_b = formData.category) === null || _b === void 0 ? void 0 : _b.id
                    : formData.category,
                exam_type_id: ((_c = formData.exam_type) === null || _c === void 0 ? void 0 : _c.id)
                    ? (_d = formData.exam_type) === null || _d === void 0 ? void 0 : _d.id
                    : formData.exam_type,
                question: formData.name,
                order_by: formData.sorting_order !== null
                    ? parseInt(((_e = formData.sorting_order) === null || _e === void 0 ? void 0 : _e.value)
                        ? (_f = formData.sorting_order) === null || _f === void 0 ? void 0 : _f.value
                        : formData.sorting_order)
                    : null,
                data_type_id: ((_g = formData.data_type) === null || _g === void 0 ? void 0 : _g.id)
                    ? (_h = formData.data_type) === null || _h === void 0 ? void 0 : _h.id
                    : formData.data_type,
                status: true,
                answer: formData.answer.length > 0
                    ? formData.answer.map(function (ans) { return ({
                        id: ans.id || null,
                        answer: ans.answer,
                        description: ans.description,
                        is_correct: ans.is_correct || false,
                        order_by: ans.order_by || null,
                        status: true,
                    }); })
                    : [],
                organization_id: organization.id,
                knowledge_id: formData.knowledge.id,
                audio: audioArr,
            };
            upsertExamQuestion({
                variables: {
                    input: [payload],
                },
            })
                .then(function (res) {
                setSuccess(res.data.upsertQuestionAnswer);
                reformatForm();
            })
                .catch(function (e) {
                console.log({ e: e });
            });
        }
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        if (formData.exam_type && formData.category && formData.organization_id) {
            getExamKnowledge({
                variables: {
                    knowledge_category_id: ((_a = formData.category) === null || _a === void 0 ? void 0 : _a.id)
                        ? (_b = formData.category) === null || _b === void 0 ? void 0 : _b.id
                        : formData.category,
                    exam_type_id: ((_c = formData.exam_type) === null || _c === void 0 ? void 0 : _c.id)
                        ? (_d = formData.exam_type) === null || _d === void 0 ? void 0 : _d.id
                        : formData.exam_type,
                    organization_id: organization.id,
                },
            });
        }
    }, [formData]);
    var onHandleChange = function (value, name, type) {
        setError(null);
        if (type === "json") {
            var dataObj_1 = JSON.parse(formData[name]);
            dataObj_1[getCurrentLang] = value;
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[name] = JSON.stringify(dataObj_1), _a)));
            });
        }
        else if (type === "obj") {
            var audio_file_1 = value.audio_file;
            if (audio_file_1) {
                setAudioFile({
                    audio: audio_file_1.name,
                });
                setFormData(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a["audio"] = __assign(__assign({}, prevState["audio"]), (_b = {}, _b[getCurrentLang] = audio_file_1, _b)), _a)));
                });
            }
        }
        else {
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[name] = value, _a)));
            });
        }
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        setQuestionSortingArr([]);
        if (((_b = (_a = examKnowledgeResponse === null || examKnowledgeResponse === void 0 ? void 0 : examKnowledgeResponse.data) === null || _a === void 0 ? void 0 : _a.getQuestionOrder) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            var list = (_c = examKnowledgeResponse === null || examKnowledgeResponse === void 0 ? void 0 : examKnowledgeResponse.data) === null || _c === void 0 ? void 0 : _c.getQuestionOrder;
            var output_1 = [];
            list.map(function (item) {
                var id = item.id, order_by = item.order_by, question = item.question, value = order_by, label = "before ".concat((0, general_1.isJsonWithAvailableLang)(question, getCurrentLang, t)), sorting_id = order_by;
                output_1.push({
                    id: id,
                    value: value,
                    label: lodash_1.default.truncate(label, {
                        length: 60,
                        omission: " ...",
                    }),
                    sorting_id: sorting_id,
                    question: question,
                });
            });
            setQuestionSortingArr(output_1);
        }
    }, [examKnowledgeResponse, getCurrentLang, formData]);
    (0, react_1.useEffect)(function () {
        if (success) {
            var timer_1 = setTimeout(function () {
                setSuccess(null);
            }, 5000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [success]);
    var onDeleteQuestion = function () {
        updateQuestionExamStatus({
            variables: {
                id: deleteRow.id,
                status: false,
                organization_id: organization.id,
            },
        }).then(function () {
            reformatForm();
            setDeleteModal(false);
            setDeleteRow(null);
            setSuccess("deleted_successfully");
        });
    };
    var onEditQuestion = function (item) {
        var formatted_exam_type = {
            id: item.exam_type.id,
            value: item.exam_type.id,
            label: (0, general_1.isJsonWithAvailableLang)(item.exam_type.name, getCurrentLang, t),
            name: item.exam_type.name,
        };
        var output = [];
        if (item.answers.length > 0) {
            item.answers.map(function (l) {
                var answer = l.answer, description = l.description, id = l.id, is_correct = l.is_correct, order_by = l.order_by, status = l.status;
                output.push({
                    answer: answer,
                    description: description,
                    is_correct: is_correct,
                    id: id,
                    order_by: order_by,
                    status: status,
                });
            });
        }
        var payload = {
            id: item.id,
            name: item.question,
            category: item.knowledge_category_id,
            exam_type: item.exam_type.id,
            exam_type_item: formatted_exam_type,
            data_type: item.data_type_id,
            data_type_item: item.data_type,
            sorting_order: item.order_by,
            answer: output,
            organization_id: organization.id,
            knowledge: knowlegdeList.length > 0 &&
                knowlegdeList.find(function (l) { return l.id === item.knowledge_id; }),
            audio: props.languages,
        };
        setFormData(payload);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (upsertExamQuestionResponse === null || upsertExamQuestionResponse === void 0 ? void 0 : upsertExamQuestionResponse.loading) && react_1.default.createElement(common_1.Spinner, null),
        (((_a = upsertExamQuestionResponse === null || upsertExamQuestionResponse === void 0 ? void 0 : upsertExamQuestionResponse.data) === null || _a === void 0 ? void 0 : _a.upsertExamQuestion) || success) && (react_1.default.createElement(common_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t(((_b = upsertExamQuestionResponse === null || upsertExamQuestionResponse === void 0 ? void 0 : upsertExamQuestionResponse.data) === null || _b === void 0 ? void 0 : _b.upsertExamQuestion) || success), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        react_1.default.createElement(common_1.ReactModal, { showSaveButton: true, modalCardStyle: { height: "10vh" }, isOpen: deleteModal, title: t("delete_confirmation"), isClose: function () { return setDeleteModal(false); }, onSaveClick: function () {
                onDeleteQuestion();
            } }, "Are you sure that you want to delete the selected item?"),
        react_1.default.createElement("div", { className: "form-container" },
            react_1.default.createElement(CategorySelector_1.default, { error: error && error.field === "category" && t(error.message), label: t("category"), list: ((_c = props.getResponse) === null || _c === void 0 ? void 0 : _c.data)
                    ? props.getResponse.data.getKnowledgeCategory
                    : [], updateCategory: function (val) {
                    onHandleChange(val, "category", "");
                    setKnowledgeList(val.knowledge);
                }, value: formData.category }),
            react_1.default.createElement(KnowledgeSelector_1.default, { error: error && error.field === "knowledge" && t(error.message), label: t("knowledge"), list: knowlegdeList, onChange: function (val) {
                    onHandleChange(val, "knowledge", "");
                }, value: formData.knowledge }),
            react_1.default.createElement(QuestionType_1.default, { error: error && error.field === "exam_type" && t(error.message), label: t("exam_type"), onChange: function (val) {
                    onHandleChange(val, "exam_type", "");
                    setFormData(function (prevState) {
                        var _a;
                        return (__assign(__assign({}, prevState), (_a = {}, _a["answer"] = [], _a)));
                    });
                }, value: formData.exam_type }),
            react_1.default.createElement(common_1.TextArea, { error: error && error.field === "name" && t(error.message), label: t("name"), onChange: function (e) { return onHandleChange(e.target.value, "name", "json"); }, value: (0, general_1.isJsonWithAvailableLang)(formData.name, getCurrentLang.toLowerCase(), t) }),
            react_1.default.createElement(DataType_1.default, { error: error && error.field === "data_type" && t(error.message), label: t("data_type"), onChange: function (val) { return onHandleChange(val, "data_type", ""); }, value: formData.data_type }),
            react_1.default.createElement(QuestionSelector_1.default, { error: error && error.field === "sorting_order" && t(error.message), label: t("sorting_order"), onChange: function (val) { return onHandleChange(val, "sorting_order", ""); }, value: formData.sorting_order, list: questionSortingArr }),
            react_1.default.createElement(common_1.ImagePicker, { fileName: audioFile, id: "audio", imagechange: function (audio_file) {
                    var file = { audio_file: audio_file };
                    onHandleChange(file, "audio", "obj");
                }, imgref: audioRef, label: t("audio_question"), mediatype: "audio" }),
            (typeof formData.exam_type != "string" &&
                ((_d = formData.exam_type) === null || _d === void 0 ? void 0 : _d.name) &&
                JSON.parse((_e = formData.exam_type) === null || _e === void 0 ? void 0 : _e.name)["en"].toLowerCase() ===
                    "evaluate") ||
                (typeof formData.exam_type === "string" &&
                    ((_f = formData.exam_type_item) === null || _f === void 0 ? void 0 : _f.name) &&
                    JSON.parse((_g = formData.exam_type_item) === null || _g === void 0 ? void 0 : _g.name)["en"].toLowerCase() ===
                        "evaluate") ? (react_1.default.createElement(KnowledgeQuestionAnswer_1.default, { deleteMessage: function (msg) { return deleteRow(msg); }, editableAnswers: formData.answer, error: error, languages: props.languages, handleMultipleAnswer: function (e) {
                    setFormData(function (prevState) {
                        var _a;
                        return (__assign(__assign({}, prevState), (_a = {}, _a["answer"] = e, _a)));
                    });
                } })) : (react_1.default.createElement(react_1.default.Fragment, null))),
        react_1.default.createElement(QuestionTable_1.default, { list: (formData === null || formData === void 0 ? void 0 : formData.knowledge) && ((_j = (_h = formData === null || formData === void 0 ? void 0 : formData.knowledge) === null || _h === void 0 ? void 0 : _h.exam_questions) === null || _j === void 0 ? void 0 : _j.length) > 0
                ? (_k = formData === null || formData === void 0 ? void 0 : formData.knowledge) === null || _k === void 0 ? void 0 : _k.exam_questions
                : [], hasHierarchy: false, onQuestiondelete: function (e) {
                // onDeleteQuestion(e);
                setDeleteRow(e);
                setDeleteModal(true);
            }, onQuestionedit: function (item) { return onEditQuestion(item); } })));
};
exports.default = KnowledgeQuestion;
